import { accountActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  error: '',
  forgotPassword: {
    data: null,
    message: '',
  },
  resetPassword: {
    data: null,
    message: '',
  },
};

const AccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        forgotPassword: {
          data: null,
          message: '',
        },
      };
    case ACTION.FORGOT_PASSWORD_SUCCESS:
      let { data, message } = action.payload;
      return {
        ...state,
        loading: false,
        error: '',
        forgotPassword: {
          data: data,
          message: message,
        },
      };
    case ACTION.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        forgotPassword: {
          data: null,
          message: '',
        },
      };
    case ACTION.REMOVE_FORGOT_PASSWORD_DATA:
      return {
        ...state,
        error: '',
        loading: false,
        forgotPassword: {
          data: null,
          message: '',
        },
      };
    case ACTION.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        resetPassword: {
          data: null,
          message: '',
        },
      };
    case ACTION.RESET_PASSWORD_SUCCESS:
      let { data: resetPasswordData, message: resetPasswordMessage } = action.payload;
      return {
        ...state,
        loading: false,
        error: '',
        resetPassword: {
          data: resetPasswordData,
          message: resetPasswordMessage,
        },
      };
    case ACTION.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        resetPassword: {
          data: null,
          message: '',
        },
      };
    case ACTION.REMOVE_RESET_PASSWORD_DATA:
      return {
        ...state,
        error: '',
        loading: false,
        resetPassword: {
          data: null,
          message: '',
        },
      };
    default:
      return state;
  }
};

export default AccountReducer;
